export const iconFontAwesomeSportsFitnessPersonBiking = (
	<i className="fa-solid fa-person-biking"></i>
);
